import { DEFAULT_EVENT_SLUG } from '@/config/appDefaults';

/** Event slug for GET /azdance/:slug — см. `DEFAULT_EVENT_SLUG` в `appDefaults`. */
export function getDefaultEventSlug(): string {
  return DEFAULT_EVENT_SLUG;
}
